// extracted by mini-css-extract-plugin
export default {"container":"OurProjects_container__QHeQT"};